<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="container py-3">
      <div
        class="row flex-nowrap pt-3 mx-2 justify-content-between align-items-center"
      >
        <a href="https://www.chanchao.com.tw/">
          <div class="d-flex">
            <img
              src="../../assets/images/ChanChaoLogo.png"
              class="navLogo mt-2"
            />
            <div class="ml-2 mt-1 mt-md-0">
              <div class="navHead font-weight-nomal">展昭會員</div>
              <div class="text-muted navCnt">ChanChao Member</div>
            </div>
          </div>
        </a>

        <div>
          <select
            class="form-control language-select"
            v-model="selectedLang"
            @change="switchLanguage"
          >
            <option
              v-for="lang in languages"
              :key="lang.value"
              :value="lang.value"
            >
              {{ lang.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="lineRight col-md-7 mt-4 mb-md-4 mb-0 px-4">
          <div class="d-flex justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <img
                src="../../assets/images/loginIcon.png"
                class="mr-2"
                style="width: 40px; height: 40px"
                alt=""
              />
              <h4>會員登入</h4>
            </div>
            <!-- <div class="btn btn-light border" @click="toLineAuth">
              <div class="d-flex align-items-center" style="display: inline-block">
                <div>
                  <img src="../../assets/images/LINE_logo.png" style="width: 25px; height: 25px" alt="" />
                </div>
                <div class="ml-2 mt-1 mt-md-0" style="font-size: 15px">Line帳號登入</div>
              </div>
            </div> -->
          </div>

          <form>
            <div class="form-group h6">
              <label for="loginEmail">電子郵件地址</label>
              <input
                type="email"
                class="form-control"
                name="email"
                maxlength="50"
                placeholder="請輸入您註冊時的電子郵件"
                id="loginEmail"
                aria-describedby="emailHelp"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                v-model="email"
                ref="loginEmail"
              />
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('email')"
                >{{ errors.first("email") }}
              </span>
            </div>

            <div class="form-group h6">
              <label for="loginPassword">密碼</label>
              <div class="input-group mb-3">
                <input
                  :type="typePwd"
                  class="form-control"
                  name="password"
                  id="loginPassword"
                  autocomplete="off"
                  placeholder="請輸入您設定的密碼"
                  maxlength="20"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-model="password"
                  v-validate="'required'"
                  ref="loginPassword"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text"
                    id="basic-addon2"
                    @click.prevent="showPw"
                  >
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i class="fas fa-eye-slash" v-else="typePwd == 'text'"></i>
                  </span>
                </div>
              </div>
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('password')"
                >密碼欄位不能留空
              </span>
            </div>

            <div class="form-group h6">
              <label for="loginPassword2">驗證碼</label>
              <div class="d-flex justify-content-around align-items-center">
                <input
                  type="text"
                  name="text"
                  maxlength="5"
                  placeholder="驗證碼不分大小寫"
                  class="form-control mr-1"
                  id="loginPassword2"
                  v-model="Validcode"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  ref="loginPassword2"
                />
                <img
                  :src="getsrc"
                  class="img-fluid rounded"
                  @click.prevent="resetValidcode"
                  style="width: 120px; height: 35px"
                />
                <a href="#" @click.prevent="resetValidcode">
                  <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                </a>
              </div>
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('text')"
                >驗證碼欄位不能留空
              </span>
            </div>

            <div class="text-muted" style="font-size: 14px">
              登入等同您同意我們的<a
                href="//www.chanchao.com.tw/otherMember.asp"
                target="_blank"
                >服務條款</a
              >
            </div>

            <button
              type="submit"
              class="btn btn-block btn-primary mt-4"
              @click.prevent="loginBtn"
            >
              登入
            </button>
          </form>

          <hr />
          <div class="mb-3">
            <img
              src="https://www.chanchao.com.tw/images/btn_login_base.png"
              style="cursor: pointer"
              width="140"
              @click="toLineAuth"
              alt=""
            />
          </div>

          <div class="MbDevice_block">
            <div class="my-2" v-if="socialBrowser" style="font-size: 15px">
              請使用您的LINE帳號及密碼登入，勿點選"使用LINE應用程式登入"，以確保順利進行LINE登入流程。

              <hr />
            </div>
          </div>

          <div class="mb-1">登入遇到困難?</div>
          <div class="linkFrame">
            <router-link to="/forgetPw">忘記密碼或重設密碼</router-link>

            <span class="linkText ml-2 pl-2 MbDevice_inline">
              <router-link to="/signup"
                ><span class="linkLine"></span>會員註冊</router-link
              >
            </span>

            <a
              href="//www.chanchao.com.tw/contact.asp"
              target="_blank"
              class="linkText ml-2 pl-2"
            >
              <span class="linkLine"></span>聯絡客服</a
            >
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <QA />
        </div>
      </div>
    </div>
    <Footer />

    <router-view></router-view>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import QA from "@/components/QA.vue";
import Footer from "@/components/footer.vue";

export default {
  components: {
    QA,
    Footer,
  },

  data() {
    return {
      getsrc: "",
      isLoading: false,
      typePwd: "password",
      email: "",
      password: "",
      Validcode: "",
      CSRF_Token: "",
      redirect_url: "",
      alertTitle: "",
      alertText: "",
      access_token: "",
      lastUrl: "",
      socialBrowser: false,
      selectedLang: "tw",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
        { label: "বাংলা ভাষা", value: "bd" },
      ],
    };
  },

  watch: {
    Validcode: function () {
      const vm = this;
      vm.$refs.loginPassword2.style.borderColor = "#ced4da";
    },

    email: function () {
      const vm = this;
      vm.$refs.loginEmail.style.borderColor = "#ced4da";
    },

    password: function () {
      const vm = this;
      vm.$refs.loginPassword.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/login`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/login`;
      }
    },
    toLineAuth() {
      const vm = this;

      if (vm.socialBrowser) {
        alert(
          '請使用您的LINE帳號及密碼登入，勿點選"使用LINE應用程式登入"，以確保順利進行LINE登入流程。',
        );
        let url = "https://www.chanchao.com.tw";
        vm.$http.get(url + "/apiLine/LineLogin").then((res) => {
          window.location.href = res.data.lineLoginUrl;
        });
      } else {
        let url = "https://www.chanchao.com.tw";
        vm.$http.get(url + "/apiLine/LineLogin").then((res) => {
          window.location.href = res.data.lineLoginUrl;
        });
      }
    },

    resetValidcode() {
      const vm = this;
      vm.$http
        .get("https://www.chanchao.com.tw/apiLogin2/Validcode")
        .then((response) => {
          vm.getsrc = response.data;
        });
    },

    loginBtn() {
      const vm = this;
      const url = "https://www.chanchao.com.tw/apiLogin2/Login";
      const info = {
        login: vm.email,
        password: vm.password,
        Validcode: vm.Validcode,
        CSRF: vm.CSRF_Token,
      };

      vm.$validator.validate().then((valid) => {
        if (valid) {
          vm.$http.post(url, info).then(function (response) {
            // // console.log(response)
            if (response.data == "200") {
              if (vm.lastUrl) {
                window.location.replace(vm.lastUrl);
              } else {
                window.location.replace("https://www.chanchao.com.tw/");
              }
            } else if (response.data == "252") {
              vm.alertText = "您的郵件地址輸入錯誤！";
              vm.alertError();
              vm.$refs.loginEmail.style.borderColor = "red";
            } else if (response.data == "253") {
              vm.alertText = "您的密碼輸入錯誤！";
              vm.alertError();
              vm.$refs.loginPassword.style.borderColor = "red";
            } else if (response.data == "254") {
              vm.alertText = "您的驗證碼輸入錯誤！";
              vm.alertError();
              vm.$refs.loginPassword2.style.borderColor = "red";
            } else if (response.data == "255") {
              window.location.replace("https://www.chanchao.com.tw/");
            } else if (response.data == "258") {
              vm.alertText = "請在您的瀏覽器中啟用cookie並再次登入！";
              vm.alertError();
              vm.$refs.loginPassword2.style.borderColor = "red";
            } else {
              vm.alertText = "系統忙碌，請稍後登入！";
              vm.alertError();
            }
          });
        } else {
          vm.alertText = "輸入欄位不完整，請重新檢查！";
          vm.alertError();
        }
      });
    },

    alertError() {
      const vm = this;
      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    showPw() {
      const vm = this;
      vm.typePwd = vm.typePwd === "password" ? "text" : "password";
    },
  },

  created() {
    const vm = this;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (
      userAgent.includes("FBAN") ||
      userAgent.includes("FBAV") ||
      userAgent.includes("Instagram") ||
      userAgent.includes("team+") ||
      userAgent.includes("MicroMessenger")
    ) {
      vm.socialBrowser = true;
    } else {
      vm.socialBrowser = false;
    }

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/Validcode")
      .then((response) => {
        vm.getsrc = response.data;
      });

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //GET LANDING PAGE

    //取得上頁的網址
    //如果上頁網址有值，代表是非vue路徑裡，就執行驗證是否為展昭網域，如果是就存到LS再取出掛載至變數
    //如果上頁網址沒有值，就執行

    let lastPage = document.referrer;
    let domain = lastPage.split("/")[2];
    let noaccount = lastPage.split("/")[3]; //排除account Url
    let domain_head = domain.split(".")[1].split(".")[0];
    let first_head = domain.split(".")[0];

    //如果上一頁是展昭的網域，那就將此網址存到LS裡，並放在lastUrl變數裡
    //如果不是就存官網網址

    if (
      first_head == "vtg" ||
      first_head == "dtg" ||
      first_head == "hanoiplas" ||
      first_head == "vietnamprintpack" ||
      first_head == "intelligentasia-thailand" ||
      first_head == "vietnamplas" ||
      first_head == "ipf" ||
      first_head == "vietnamwood" ||
      first_head == "tfpe" ||
      first_head == "3dprinting" ||
      first_head == "logistics" ||
      first_head == "taimold" ||
      first_head == "laserexpo" ||
      first_head == "twsf-tainan" ||
      first_head == "tnntcfs" ||
      first_head == "automationtaipei" ||
      first_head == "twsf-taipeispring" ||
      first_head == "hanoiintelligent" ||
      first_head == "ctg" ||
      first_head == "tpvde" ||
      first_head == "outdoor-taichung" ||
      first_head == "cambodiappp" ||
      first_head == "twsf-white" ||
      first_head == "cimif" ||
      first_head == "fishing-tackle" ||
      first_head == "meow-kaohsiung" ||
      first_head == "tairos" ||
      first_head == "outdoor-taipei" ||
      first_head == "outdoor-kaohsiung" ||
      first_head == "ktcfs" ||
      first_head == "pets-taichung" ||
      first_head == "pets-taipei" ||
      first_head == "tairex" ||
      first_head == "vibs" ||
      first_head == "hanoiprintpack" ||
      first_head == "twsf-kaohsiung"
    ) {
      //改版官網存入sessionStorage的網址

      vm.lastUrl = vm.$cookies.get("RecordUrl");
    } else {
      if (lastPage && noaccount !== "accounts") {
        if (domain == "www.chanchao.com.tw" || domain_head == "chanchao") {
          //如果網域為展昭

          vm.$cookies.set("url", lastPage, 60 * 60);
          vm.lastUrl = vm.$cookies.get("url");
        } else {
          vm.lastUrl = "https://www.chanchao.com.tw/"; //如果不是展昭網域，就導回首頁
        }
      } else {
        if (vm.$cookies.get("url")) {
          vm.lastUrl = vm.$cookies.get("url");
        } else {
          vm.lastUrl = "https://www.chanchao.com.tw/";
        }
      }
    }

    //更換英文語系
    vm.$i18n.locale = "zhTW";
  },
};
</script>

<style lang="scss">
//Swal
.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 10px;
}

.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.lineRight {
  border-right: 1px solid #ccc;
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.navHead {
  font-size: 29px;
  color: #2c3e50;
}

.navCnt {
  font-size: 17px;
}

.navLogo {
  height: 55px;
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

.linkFrame {
  font-size: 15px;
}

.linkText {
  position: relative;
}

.linkLine {
  position: absolute;
  height: 13px;
  //width: 33px;
  top: 20%;
  left: 0;
  border-left: 2px solid #a1a7a8;
}

@media (max-width: 768px) {
  .lineRight {
    border-right: 0px;
  }

  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
  }

  .navEnText {
    display: none;
  }

  .navHead {
    font-size: 23px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 14px;
  }

  .navLogo {
    height: 50px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
